import Cookie from 'cookie-universal';
import {
  MAIN as MAIN_COOKIE,
  CONSENT as CONSENT_COOKIE,
  SEARCHES_AFTER_INSTALL as SEARCHES_COOKIE,
  REQUEST_ID as REQUEST_ID_COOKIE,
} from '../../../common/js/constants/cookies';
import {
  COOKIE_CONSENT as LOCAL_STORAGE_CONSENT,
  EXTENSION_ACTIVE,
} from '../../../common/js/constants/storage-keys';
import { getCookieOptions } from '../../../common/js/universal/utils';
import { getTrackIdSelector } from './helpers';

const CID_END_RE = /:cid=.*?$/;
const CID_MID_RE = /cid=.*?:/;

const parseCookie = (cookieString = '') => {
  const cookie = {};
  cookieString.split(':').forEach((keyValue) => {
    const [key, value] = keyValue.split('=');
    if (key) {
      cookie[key] = value;
    }
  });
  return cookie;
};

const mapCookie = (cookie) => {
  const mappedCookie = {};
  [
    ['language', 'l', false],
    ['devicetype', 'dt', false],
    ['trees', 't', true],
    ['market', 'mc', false],
    ['autosuggest', 'as', true],
    ['custom', 'cs', true],
    ['lasttree', 'lt', true],
    ['firstsearch', 'fs', true],
    ['firstrun', 'fr', true],
    ['addon', 'a', true],
    ['typetag', 'tt', false],
    ['personal', 'pz', true],
    ['adult', 'f', false],
    ['notification', 'nf', true],
    ['newtab', 'nt', true],
    ['country', 'c', false],
  ].forEach(([mappedName, cookieName, isInteger]) => {
    let value = cookie[cookieName];
    value = value === undefined ? null : value;
    if (isInteger) {
      value = isNaN(value) ? null : value;
      value = parseInt(value, 10);
    }
    mappedCookie[mappedName] = value;
  });
  return mappedCookie;
};

export const getExperiments = () => {
  const abTests = document.querySelector(getTrackIdSelector('goodall'));
  if (!abTests) {
    return {};
  }
  const experiments = {};
  Object.keys(abTests.dataset).forEach((key) => {
    if (key.startsWith('exp')) {
      const cleanKey = key.replace(/^exp/, '').toLowerCase();
      experiments[cleanKey] = abTests.dataset[key];
    }
  });
  return experiments;
};

export const getMainCookieContext = () => {
  const cookies = Cookie();
  const cookieString = cookies.get(MAIN_COOKIE, getCookieOptions());
  const ecsaiCookie = cookies.get(SEARCHES_COOKIE, getCookieOptions());

  const extensionActive = sessionStorage.getItem(EXTENSION_ACTIVE);

  if (!cookieString) {
    return null;
  }
  const cookie = parseCookie(cookieString);
  const context = mapCookie(cookie);
  context.extension = ecsaiCookie || extensionActive ? 1 : 0;
  context.lasttree = context.lasttree === 0 ? null : context.lasttree;
  context.ecfgcookie = cookieString.replace(CID_MID_RE, '').replace(CID_END_RE, '');
  return context;
};

export const getConsentCookieContext = () => {
  const cookies = Cookie();
  const cookieString = cookies.get(CONSENT_COOKIE, getCookieOptions());
  let localStorageConsent = null;

  if (typeof localStorage !== 'undefined') {
    localStorageConsent = localStorage.getItem(LOCAL_STORAGE_CONSENT);
  }

  return cookieString || localStorageConsent || '';
};

export const getRequestID = () => {
  const cookies = Cookie();
  const cookieString = cookies.get(REQUEST_ID_COOKIE, getCookieOptions());
  return cookieString || '';
};
